import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../redux/data/dataActions";

function Breed() {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const [balanceOf, setBalanceOf] = useState(0);
  const [claimingNft, setClaimingNft] = useState(false);
  // eslint-disable-next-line
  const [feedback, setFeedback] = useState(`Click buy to mint your NFT.`);
  // eslint-disable-next-line
  const data = useSelector((state) => state.data);

  const [CONFIG, SET_CONFIG] = useState({
    ECOZ_CONTRACT_ADDRESS: "",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 0,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });

  const breedJaguar = () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost);
    let totalGasLimit = String(gasLimit);

    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);

    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);

    blockchain.smartContract.methods
      .BreedJaguar()
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.ECOZ_CONTRACT_ADDRESS,
        from: blockchain.account,
        value: 0,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit Opensea.io to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const breedBushBuck = () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost);
    let totalGasLimit = String(gasLimit);

    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);

    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);

    blockchain.smartContract.methods
      .BreedBushBuck()
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.ECOZ_CONTRACT_ADDRESS,
        from: blockchain.account,
        value: 0,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit Opensea.io to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const breedBananaTree = () => {
    let cost = CONFIG.WEI_COST;
    let gasLimit = CONFIG.GAS_LIMIT;
    let totalCostWei = String(cost);
    let totalGasLimit = String(gasLimit);

    console.log("Cost: ", totalCostWei);
    console.log("Gas limit: ", totalGasLimit);

    setFeedback(`Minting your ${CONFIG.NFT_NAME}...`);
    setClaimingNft(true);

    blockchain.smartContract.methods
      .BreedBananaTree()
      .send({
        gasLimit: String(totalGasLimit),
        to: CONFIG.ECOZ_CONTRACT_ADDRESS,
        from: blockchain.account,
        value: 0,
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        console.log(receipt);
        setFeedback(
          `WOW, the ${CONFIG.NFT_NAME} is yours! go visit Opensea.io to view it.`
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.smartContract !== null) {
      balance();
      dispatch(fetchData(blockchain.account));
    }
  };

  const balance = () => {
    blockchain.smartContract2.methods
      .balanceOf(blockchain.account)
      .call((err, res) => {
        if (err) {
          console.log(err);
        } else {
          setBalanceOf(res);
        }
      });
  };

  const getConfig = async () => {
    const configResponse = await fetch("/config/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };

  useEffect(() => {
    getConfig();
  }, []);

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [blockchain.account]);

  return (
    <div className="mt-16 Breed">
      <h1
        class="title-font sm:text-7xl text-4xl my-4 font-medium  orange-text "
        style={{ fontFamily: "font1" }}
      >
        Breed
      </h1>

      <section class="text-black body-font sm:mt-16">
        <div class="container px-5 py-8 mx-auto">
          <div class="flex justify-center">
            <div class="flex overflow-x-scroll pb-4">
              <div class="flex flex-nowrap  ">
                <div class="inline-block px-3">
                  <div class="w-64 h-96 max-w-xs overflow-hidden rounded-lg  duration-300 ease-in-out ">
                    <div class="flex-grow ">
                      <div class="flex justify-center sm:mb-8 mb-2">
                        <img
                          src="AVATARS/BabyJaguar.png"
                          alt="jaguar"
                          class="sm:h-24 h-10"
                        />
                      </div>

                      {balanceOf > data.breedCostJag ? (
                        <p class="leading-relaxed text-base sm:mb-8 mb-2">
                          {balanceOf}/{data.breedCostJag} $THRIVE
                        </p>
                      ) : (
                        <p class="leading-relaxed text-red-500 sm:mb-8 mb-2">
                          {balanceOf}/{data.breedCostJag} $THRIVE
                        </p>
                      )}
                      <p class="leading-relaxed text-base text-black sm:mb-8 mb-2">
                        Population {data.babyJagSupply}
                      </p>
                      <a
                        href
                        class="mt-3 text-indigo-500 inline-flex items-center"
                      >
                        <button
                          disabled={claimingNft ? 1 : 0}
                          onClick={(e) => {
                            e.preventDefault();
                            breedJaguar();
                            getData();
                          }}
                          class="orange border-white border-2 shadow-md text-white px-10 p-2 text-md hover:scale-105 transition duration-500 ease-in-out transform hover:shadow-lg hover:text-orange"
                        >
                          Breed Jaguar
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="inline-block px-3">
                  <div class="w-64 h-96 max-w-xs overflow-hidden rounded-lg  duration-300 ease-in-out">
                    <div class="flex-grow ">
                      <div class="flex justify-center sm:mb-8 mb-2">
                        <img
                          src="AVATARS/BabyBushBuck.png"
                          alt="Bush"
                          class="sm:h-24 h-10"
                        />
                      </div>
                      {balanceOf > data.breedCostBush ? (
                        <p class="leading-relaxed text-base sm:mb-8 mb-2">
                          {balanceOf}/{data.breedCostBuck} $THRIVE
                        </p>
                      ) : (
                        <p class="leading-relaxed text-red-500 sm:mb-8 mb-2">
                          {balanceOf}/{data.breedCostBuck} $THRIVE
                        </p>
                      )}

                      <p class="leading-relaxed text-base sm:mb-8 mb-2">
                        Population {data.babyBuckSupply}
                      </p>
                      <a
                        href
                        class="mt-3 text-indigo-500 inline-flex items-center"
                      >
                        <button
                          disabled={claimingNft ? 1 : 0}
                          onClick={(e) => {
                            e.preventDefault();
                            breedBushBuck();
                            getData();
                          }}
                          class="orange border-white border-2 shadow-md text-white px-10 p-2 text-md hover:scale-105 transition duration-500 ease-in-out transform hover:shadow-lg hover:text-orange"
                        >
                          Breed Bush Buck
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="inline-block px-3">
                  <div class="w-64 h-96 max-w-xs overflow-hidden rounded-lg  duration-300 ease-in-out">
                    <div class="flex-grow ">
                      <div class="flex justify-center sm:mb-8 mb-2">
                        <img
                          src="AVATARS/BabyBananaTree.png"
                          alt="tree"
                          class="sm:h-24 h-10"
                        />
                      </div>

                      {balanceOf > data.breedCostTree ? (
                        <p class="leading-relaxed text-base sm:mb-8 mb-2">
                          {balanceOf}/{data.breedCostTree} $THRIVE
                        </p>
                      ) : (
                        <p class="leading-relaxed text-red-500 sm:mb-8 mb-2">
                          {balanceOf}/{data.breedCostTree} $THRIVE
                        </p>
                      )}

                      <p class="leading-relaxed text-base sm:mb-8 mb-2">
                        Population {data.babyTreeSupply}
                      </p>
                      <a
                        href
                        class="mt-3 text-indigo-500 inline-flex items-center"
                      >
                        <button
                          disabled={claimingNft ? 1 : 0}
                          onClick={(e) => {
                            e.preventDefault();
                            breedBananaTree();
                            getData();
                          }}
                          class="orange border-white border-2 shadow-md text-white px-10 p-2 text-md hover:scale-105 transition duration-500 ease-in-out transform hover:shadow-lg hover:text-orange"
                        >
                          Breed Banana Tree
                        </button>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Breed;
